import {CONFIG} from 'redux/actionTypes';

import Api from 'services/Api';


export const get = () => {
	return (dispatch) => {
		dispatch({
			type: CONFIG.FETCHING,
		});
		Api.get(
			{},
			'config/',
			(error, data) => {
				if (error) {
					return dispatch({
						type: CONFIG.ERROR,
						payload: {
							message: error,
						},
					});
				}

				return dispatch({
					type: CONFIG.GET,
					payload: data
				});
			}
		);
	};
};
